import React, { type FC, type ReactElement } from 'react';

import { useAuth } from '~/hooks/useAuth';

const PhoneNumber: FC<{
  value: string | null | undefined;
}> = function ({ value }): ReactElement {
  if (!value) {
    return <span className='PhoneNumber PhoneNumber--empty'></span>;
  }

  const { user } = useAuth();

  const format = user?.phoneNumberFormat ?? '(###) ###-####';

  let position = 0;
  return (
    <span className={`PhoneNumber${value.length !== 10 ? ' PhoneNumber--invalid' : ''}`}>
      {format
        .split('')
        .map((c: string) => {
          if (position >= value.length) {
            return '';
          }

          switch (c) {
            case '#':
              position++;
              return value[position - 1];
            default:
              return c;
          }
        })
        .join('')}
      {position < value.length ? value.substring(position) : ''}
    </span>
  );
};

export default PhoneNumber;
